export default {
    path: "/engineering",
    redirect: "/engineering/project",
    meta: {
        title: "工程部",
        permissionCode: "",
    },
    children: [
        {
            meta: {
                title: "项目信息管理",
                permissionCode: "pcEnginerList",
                keepAlive: true,
                name: "pcEnginerList"
            },
            path: "/engineering/project/info",
            component: () => import("@/views/engineering/project/info/list.vue"),
        },
        {
            meta: {
                title: "修改项目信息",
                permissionCode: "pcEnginerEdit",
                state: "edit",
                keepAlive:true,
                name:"pcEnginerListForm"
            },
            path: "/engineering/project/edit",
            component: () =>
                import("@/views/engineering/project/info/detail.vue"),
            props: { state: "edit" },
        },
        {
            meta: {
                title: "查看项目信息",
                permissionCode: "pcEnginerAuth",
                state: "look",
                keepAlive:true,
                name:"pcEnginerListForm"
            },
            component: () =>
                import("@/views/engineering/project/info/detail.vue"),
            path: "/engineering/project/look",
        },
        {
            meta: {
                title: "项目进场启动会登记",
                permissionCode: "pcEnginerSetup",
            },
            path: "/engineering/project/start",
            component: () =>
                import("@/views/engineering/project/start/index.vue"),
        },
        {
            meta: {
                title: "样板施工登记",
                permissionCode: "pcEnginerSample",
            },
            path: "/engineering/project/sample",
            component: () =>
                import("@/views/engineering/project/sample/index.vue"),
        },
        {
            meta: {
                title: "项目变更管理",
                permissionCode: "pcEnginerProjectChange",
                keepAlive: true,
                name:"pcEnginerProjectChange"
            },
            path: "/engineering/project/projectChange/list",
            component: () => import("@/views/engineering/project/projectChange/list.vue"),
        },
        {
            meta: {
                title: "项目变更管理新增/编辑",
                permissionCode: "pcEnginerProjectChangeEdit",
                keepAlive: true,
                name:"pcEnginerProjectChangeForm"
            },
            path: "/engineering/project/projectChange/details",
            component: () => import("@/views/engineering/project/projectChange/details.vue"),
        },
        {
            meta: {
                title: "施工日志管理",
                permissionCode: "pcEnginerProjectLogList",
                keepAlive: true,
                name:"pcEnginerProjectLogList"
            },
            path: "/engineering/project/projectLog/list",
            component: () => import("@/views/engineering/project/projectLog/list.vue"),
        },
        {
            meta: {
                title: "施工日志管理",
                permissionCode: "pcEnginerProjectLogEdit",
                keepAlive: true,
                name:"pcEnginerProjectLogForm"
            },
            path: "/engineering/project/projectLog/details",
            component: () => import("@/views/engineering/project/projectLog/details.vue"),
        },
        {
            meta: {
                title: "安全技术交底登记",
                permissionCode: "pcSafeManageSafeList",
                keepAlive: true,
                name:"pcSafeManageSafeList",
            },
            path: "/engineering/safeManage/safe/list",
            component: () => import("@/views/engineering/safeManage/safe/list.vue"),
        },
        {
            meta: {
                title: "安全技术交底登记",
                permissionCode: "pcSafeManageSafeEdit",
                keepAlive: true,
                name:"pcSafeManageSafeForm"
            },
            path: "/engineering/safeManage/safe/details",
            component: () => import("@/views/engineering/safeManage/safe/details.vue"),
        },
        {
            meta: {
                title: "三级教育登记",
                permissionCode: "pcSafeManageEducationList",
                keepAlive: true,
                name:"pcSafeManageEducationList"

            },
            path: "/engineering/safeManage/education/list",
            component: () => import("@/views/engineering/safeManage/education/list.vue"),
        },
        {
            meta: {
                title: "三级教育登记新增/编辑",
                permissionCode: "pcSafeManageEducationEdit",
                keepAlive: true,
                name:"pcSafeManageEducationForm"
            },
            path: "/engineering/safeManage/education/details",
            component: () => import("@/views/engineering/safeManage/education/details.vue"),
        },
        {
            meta: {
                title: "安全会议登记",
                permissionCode: "pcSafeManageMeetingList",
                keepAlive: true,
                name:"pcSafeManageMeetingList"
            },
            path: "/engineering/safeManage/meeting/list",
            component: () => import("@/views/engineering/safeManage/meeting/list.vue"),
        },
        {
            meta: {
                title: "安全会议登记新增/编辑",
                permissionCode: "pcSafeManageMeetingEdit",
                keepAlive: true,
                name:"pcSafeManageMeetingForm"
            },
            path: "/engineering/safeManage/meeting/details",
            component: () => import("@/views/engineering/safeManage/meeting/details.vue"),
        },
        {
            meta: {
                title: "奖惩记录",
                permissionCode: "pcSafeManageRecordList",
                keepAlive: true,
                name:"pcSafeManageRecordList"
            },
            path: "/engineering/safeManage/record/list",
            component: () => import("@/views/engineering/safeManage/record/list.vue"),
        },
        {
            meta: {
                title: "奖惩记录新增/编辑",
                permissionCode: "pcSafeManageRecordEdit",
                keepAlive: true,
                name:"pcSafeManageRecordForm"
            },
            path: "/engineering/safeManage/record/details",
            component: () => import("@/views/engineering/safeManage/record/details.vue"),
        },
        {
            meta: {
                title: "奖惩记录审核",
                permissionCode: "pcSafeManageRecordList",
            },
            path: "/engineering/safeManage/record/auth",
            component: () => import("@/views/engineering/safeManage/record/auth.vue"),
        },
        {
            meta: {
                title: "安全日志登记",
                permissionCode: "pcSafeManageLogList",
                keepAlive: true,
                name:"pcSafeManageLogList"
            },
            path: "/engineering/safeManage/log/list",
            component: () => import("@/views/engineering/safeManage/log/list.vue"),
        },
        {
            meta: {
                title: "安全日志登记新增/编辑",
                permissionCode: "pcSafeManageLogEdit",
                keepAlive: true,
                name:"pcSafeManageLogForm"
            },
            path: "/engineering/safeManage/log/details",
            component: () => import("@/views/engineering/safeManage/log/details.vue"),
        },
        {
            meta: {
                title: "强管节点检查申请",
                permissionCode: "pcQualityManageNodeList",
                keepAlive: true,
                name:"pcQualityManageNodeList"

            },
            path: "/engineering/qualityManage/node/list",
            component: () => import("@/views/engineering/qualityManage/node/list.vue"),
        },
        {
            meta: {
                title: "强管节点检查新增/编辑",
                permissionCode: "pcQualityManageNodeEdit",
                keepAlive: true,
                name:"pcQualityManageNodeForm"
            },
            path: "/engineering/qualityManage/node/details",
            component: () => import("@/views/engineering/qualityManage/node/details.vue"),
        },
        {
            meta: {
                title: "实测实量管理",
                permissionCode: "pcQualityManageMeasureList",
                keepAlive: true,
                name:"pcQualityManageMeasureList"
            },
            path: "/engineering/qualityManage/measure/list",
            component: () => import("@/views/engineering/qualityManage/measure/list.vue"),
        },
        {
            meta: {
                title: "实测实量管理新增/编辑",
                permissionCode: "pcQualityManageMeasureEdit",
                keepAlive: true,
                name:"pcQualityManageMeasureForm"
            },
            path: "/engineering/qualityManage/measure/details",
            component: () => import("@/views/engineering/qualityManage/measure/details.vue"),
        },
        {
            meta: {
                title: "实测实量管理",
                permissionCode: "pcQualityManageMeasureList",


            },
            path: "/engineering/qualityManage/measure/taskList",
            component: () => import("@/views/engineering/qualityManage/measure/taskList.vue"),
        },
        {
            meta: {
                title: "实测实量管理",
                permissionCode: "pcQualityManageMeasureList",


            },
            path: "/engineering/qualityManage/measure/troubleList",
            component: () => import("@/views/engineering/qualityManage/measure/trouble.vue"),
        },
        {
            meta: {
                title: "其他检查",
                permissionCode: "pcQualityManageMeasureOtherList",

            },
            path: "/engineering/qualityManage/other/list",
            component: () => import("@/views/engineering/qualityManage/other/list.vue"),
        },
        {
            meta: {
                title: "其他检查新增/编辑",
                permissionCode: "pcQualityManageMeasureOtherEdit",
                keepAlive: true,
                name:'pcQualityManageMeasureOtherForm'
            },
            path: "/engineering/qualityManage/other/details",
            component: () => import("@/views/engineering/qualityManage/other/details.vue"),
        },
        {
            meta: {
                title: "其他检查",
                permissionCode: "pcQualityManageMeasureOtherList",


            },
            path: "/engineering/qualityManage/other/mouldDetails",
            component: () => import("@/views/engineering/qualityManage/other/mouldDetails.vue"),
        },
        {
            meta: {
                title: "其他检查",
                permissionCode: "pcQualityManageMeasureOtherList",


            },
            path: "/engineering/qualityManage/other/mouldList",
            component: () => import("@/views/engineering/qualityManage/other/mouldList.vue"),
        },
        {
            meta: {
                title: "开票台账",
                permissionCode: "pcProjectFinanceManageBilling",
                keepAlive: true,
                name:"pcProjectFinanceManageBilling"

            },
            path: "/engineering/financeManage/billing/list",
            component: () => import("@/views/engineering/financeManage/billing/list.vue"),
        },
        {
            meta: {
                title: "甲方收款台账",
                permissionCode: "pcProjectFinanceManagePayee",
                keepAlive: true
            },
            path: "/engineering/financeManage/payee/list",
            component: () => import("@/views/engineering/financeManage/payee/list.vue"),
        },
        {
            meta: {
                title: "乙方付款台账",
                permissionCode: "pcProjectFinanceManagePayment",
                keepAlive: true

            },
            path: "/engineering/financeManage/payment/list",
            component: () => import("@/views/engineering/financeManage/payment/list.vue"),
        },
        {
            meta: {
                title: "乙方付款台账明细",
                permissionCode: "pcProjectFinanceManagePayment",
                keepAlive: true

            },
            path: "/engineering/financeManage/payment/list/detail",
            component: () => import("@/views/engineering/financeManage/payment/detail.vue"),
        },
        {
            meta: {
                title: "其他支出台账",
                permissionCode: "pcProjectFinanceManageOtherBill",
                keepAlive: true

            },
            path: "/engineering/financeManage/otherBill/list",
            component: () => import("@/views/engineering/financeManage/otherBill/list.vue"),
        },
        {
            meta: {
                title: "成本统计",
                permissionCode: "pcProjectFinanceManageCost",


            },
            path: "/engineering/financeManage/costList/list",
            component: () => import("@/views/engineering/financeManage/costList/list.vue"),
        },

        {
            path: '/engineering/material/turnoverList',
            component: () => import("@/views/engineering/material/turnover/list.vue"),
            meta: {
                permissionCode: "pcMaterialMasterPlanListTurnover",
                title: '材料库存台账',
                keepAlive: true

            },
        },
        {
            path: '/engineering/material/turnoverDetail',
            component: () => import("@/views/engineering/material/turnover/detail.vue"),
            meta: {
                permissionCode: "pcMaterialMasterPlanListTurnover",
                title: '材料库存台账明细',
            },
        },
        {
            path: '/engineering/report/inAndOut',
            component: () => import("@/views/engineering/report/inAndOut/index.vue"),
            meta: {
                permissionCode: "pcEngineReportInAndOut",
                title: '项目收支统计',
            },
        },
        {
            path: '/engineering/report/taskSummary',
            component: () => import("@/views/engineering/report/task/index.vue"),
            meta: {
                permissionCode: "pcEngineReportTaskSummary",
                title: '工程任务单汇总表',
            },
        },
        /****************************************************************
         *
         * 材料总计划
         *
         ***************************************************************/
        {
            meta: {
                title: "材料总计划",
                permissionCode: "pcEnginerrProjectMaterialMaster",
                keepAlive: true,
                name: "pcEnginerrProjectMaterialMaster",

            },
            path: "/engineering/material/masterPlanList",
            component: () =>
                import("@/views/engineering/material/masterPlan/list.vue"),
        },

        {
            meta: {
                title: "添加材料总计划",
                permissionCode: "pcEnginerrProjectMaterialMasterAdd",
                state: "add",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialMasterForm'
            },
            path: "/engineering/material/addMasterPlanDetail",
            component: () =>
                import("@/views/engineering/material/masterPlan/detail.vue"),
        },

        {
            meta: {
                title: "修改材料总计划",
                permissionCode: "pcEnginerrProjectMaterialMasterEdit",
                state: "edit",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialMasterForm'
            },
            path: "/engineering/material/editMasterPlanDetail",
            component: () =>
                import("@/views/engineering/material/masterPlan/detail.vue"),
        },
        {
            meta: {
                title: "审核材料总计划",
                permissionCode: "pcEnginerrProjectMaterialMasterAuth",
                state: "auth",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialMasterForm'
            },
            path: "/engineering/material/authMasterPlanDetail",
            component: () =>
                import("@/views/engineering/material/masterPlan/detail.vue"),
        },
        {
            meta: {
                title: "重新申请材料总计划",
                permissionCode: "pcEnginerrProjectMaterialMasterCanApply",
                state: "canApply",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialMasterForm'
            },
            path: "/engineering/material/canApplyMasterPlanDetail",
            component: () =>
                import("@/views/engineering/material/masterPlan/detail.vue"),
        },

        /****************************************************************
         *
         * 材料分批计划
         *
         ***************************************************************/
        {
            meta: {
                title: "材料分批计划",
                permissionCode: "pcEnginerrProjectMaterialBranch",
                keepAlive: true,
                name: "pcEnginerrProjectMaterialBranch"

            },
            path: "/engineering/material/branchPlanList",
            component: () =>
                import("@/views/engineering/material/branchPlan/list.vue"),
        },
        {
            meta: {
                title: "添加材料分批计划",
                permissionCode: "pcEnginerrProjectMaterialBranchAdd",
                state: "add",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialBranchForm'

            },
            path: "/engineering/material/addBranchPlanDetail",
            component: () =>
                import("@/views/engineering/material/branchPlan/detail.vue"),
        },
        {
            meta: {
                title: "修改材料分批计划",
                permissionCode: "pcEnginerrProjectMaterialBranchEdit",
                state: "edit",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialBranchForm'
            },
            path: "/engineering/material/editBranchPlanDetail",
            component: () =>
                import("@/views/engineering/material/branchPlan/detail.vue"),
        },
        {
            meta: {
                title: "审核材料分批计划",
                permissionCode: "pcEnginerrProjectMaterialBranchAuth",
                state: "auth",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialBranchForm'
            },
            path: "/engineering/material/authBranchPlanDetail",
            component: () =>
                import("@/views/engineering/material/branchPlan/detail.vue"),
        },
        {
            meta: {
                title: "重新申请材料分批计划",
                permissionCode: "pcEnginerrProjectMaterialBranchCanApply",
                state: "canApply",
                keepAlive: true,
                name:'pcEnginerrProjectMaterialBranchForm'
            },
            path: "/engineering/material/canApplyBranchPlanDetail",
            component: () =>
                import("@/views/engineering/material/branchPlan/detail.vue"),
        },
        /****************************************************************
         *
         *
         *
         ***************************************************************/
        {
            meta: {
                title: "材料台账",
                permissionCode: "pcEnginerrProjectMaterialAccount",
                keepAlive: true

            },
            path: "/engineering/material/accountList",
            component: () =>
                import("@/views/engineering/material/account/list.vue"),
        },
        {
            meta: {
                title: "材料入库台账",
                permissionCode: "pcEnginerrProjectMaterialEntry",
                keepAlive: true,
                name:"pcEnginerrProjectMaterialEntry"
            },
            path: "/engineering/material/entryStockList",
            component: () =>
                import("@/views/engineering/material/entryStock/list.vue"),
        },
        {
            meta: {
                title: "材料入库单",
                permissionCode: "pcEnginerrProjectMaterialEntry",


            },
            path: "/engineering/material/entryStockDetail",
            component: () =>
                import("@/views/engineering/material/entryStock/detail.vue"),
        },
        {
            meta: {
                title: "材料出库台账",
                permissionCode: "pcEnginerrProjectMaterialOut",
                keepAlive: true,
                name:"pcEnginerrProjectMaterialOut"

            },
            path: "/engineering/material/outStockList",
            component: () =>
                import("@/views/engineering/material/outStock/list.vue"),
        },
        {
            meta: {
                title: "材料出库单",
                permissionCode: "pcEnginerrProjectMaterialOut",


            },
            path: "/engineering/material/outStockDetail",
            component: () =>
                import("@/views/engineering/material/outStock/detail.vue"),
        },
        {
            path: "labour",
            redirect: "/engineering/labour/contractList",
            meta: {
                title: "劳务管理",
                permissionCode: "",


            },
            component: () => import("@/router/EmptyComponent.vue"),
        },
        {
            meta: {
                title: "合同管理",
                permissionCode: "pcEnginerrProjectLabourContract",
                keepAlive: true,
                name:"pcEnginerrProjectLabourContract"
            },
            path: "/engineering/labour/contractList",
            component: () =>
                import("@/views/engineering/labour/contract/list.vue"),
        },
        {
            meta: {
                title: "班组管理",
                permissionCode: "pcEnginerrProjectLabourTeam",
                keepAlive: true,
                name:'pcEngineerProjectLabourTeamList'
            },
            path: "/engineering/labour/team",
            component: () => import("@/views/engineering/labour/team/list.vue"),
        },
        {
            meta: {
                title: "添加工人信息",
                permissionCode: "pcEnginerrProjectLabourTeamAdd",
                state: "add",
                keepAlive: true,
                name:'pcEnginerrProjectLabourTeamForm'
            },
            path: "/engineering/labour/addTeam",
            component: () =>
                import("@/views/engineering/labour/team/detail.vue"),
        },
        {
            meta: {
                title: "修改工人信息",
                permissionCode: "pcEnginerrProjectLabourTeamEdit",
                state: "edit",
                keepAlive: true,
                name:'pcEnginerrProjectLabourTeamForm'
            },
            path: "/engineering/labour/editTeam",
            component: () =>
                import("@/views/engineering/labour/team/detail.vue"),
        },
        {
            meta: {
                title: "查看工人信息",
                permissionCode: "pcEnginerrProjectLabourTeamLook",
                state: "look",
                keepAlive: true,
                name:'pcEnginerrProjectLabourTeamForm'
            },
            path: "/engineering/labour/lookTeam",
            component: () =>
                import("@/views/engineering/labour/team/detail.vue"),
        },
        {
            meta: {
                title: "打卡明细",
                permissionCode: "pcEnginerrProjectLabourTeam",


            },
            path: "/engineering/labour/punchClockDetail",
            component: () =>
                import("@/views/engineering/labour/team/punchClockDetail.vue"),
        },
        {
            meta: {
                title: "工程任务单",
                permissionCode: "pcEnginerrProjectLabourProjectTask",


            },
            path: "/engineering/labour/projectTask",
            component: () =>
                import("@/views/engineering/labour/projectTask/index.vue"),
        },
        {
            meta: {
                title: "付款计划",
                permissionCode: "pcEnginerrProjectLabourPayTaskList",
                keepAlive: true,
            },
            path: "/engineering/labour/payTaskList",
            component: () =>
                import("@/views/engineering/labour/payTask/list.vue"),
        },

        {
            meta: {
                title: "添加付款计划",
                permissionCode: "pcEnginerrProjectLabourPayTaskAdd",
                state: "add",
                keepAlive: true,
                name:'pcEnginerrProjectLabourPayTaskForm'
            },
            path: "/engineering/labour/addPayTask",
            component: () =>
                import("@/views/engineering/labour/payTask/detail.vue"),
        },
        {
            meta: {
                title: "修改付款计划",
                permissionCode: "pcEnginerrProjectLabourPayTaskEdit",
                state: "edit",
                keepAlive: true,
                name:'pcEnginerrProjectLabourPayTaskForm'
            },
            path: "/engineering/labour/editPayTask",
            component: () =>
                import("@/views/engineering/labour/payTask/detail.vue"),
        },

        {
            meta: {
                title: "劳务付款管理",
                permissionCode: "pcEngineerProjectLabourPayment",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectLabourPayment",
            },
            path: "/engineering/labour/paymentList",
            component: () => import("@/views/engineering/labour/payMgt/list.vue"),
        },




        
        {
            meta: {
                title: "劳务单包进度款申请",
                permissionCode: "pcEngineerProjectLabourPaymentProcessAdd",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:'pcEngineerProjectLabourPaymentProcessForm'

            },
            path: "/engineering/labour/progress/applyPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/progress/apply.vue"),
        },
        {
            meta: {
                title: "劳务单包进度款审核及详情",
                permissionCode: "pcEngineerProjectLabourPaymentProcessAuth",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/labour/progress/authPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/progress/auth.vue"),
        },
        {
            meta: {
                title: "劳务/双包进度款申请",
                permissionCode: "pcEngineerProjectLabourPaymentProcessAdd",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:'pcEngineerProjectDoubleLabourPaymentProcessForm'

            },
            path: "/engineering/labour/dlProgress/applyPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/dlProgress/apply.vue"),
        },
        {
            meta: {
                title: "劳务/双包进度款审核及详情",
                permissionCode: "pcEngineerProjectDoubleLabourPaymentProcessAuth",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/labour/dlProgress/authPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/dlProgress/auth.vue"),
        },






        {
            meta: {
                title: "劳务单包结算款申请",
                permissionCode: "pcEngineerProjectLabourPaymentSettleEdit",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:'pcEngineerProjectLabourPaymentSettleForm'
            },
            path: "/engineering/labour/settlement/applyPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/settlement/apply.vue"),
        },
        {
            meta: {
                title: "劳务单包结算款审核及详情",
                permissionCode: "pcEngineerProjectLabourPaymentSettleAuth",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/labour/settlement/authPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/settlement/auth.vue"),
        },
        {
            meta: {
                title: "劳务/双包结算款申请",
                permissionCode: "pcEngineerProjectLabourPaymentSettleEdit",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:'pcEngineerProjectDoubleLabourPaymentSettleForm'
            },
            path: "/engineering/labour/dlSettlement/applyPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/dlSettlement/apply.vue"),
        },
        {
            meta: {
                title: "劳务/双包结算款审核及详情",
                permissionCode: "pcEngineerProjectDoubleLabourPaymentSettleAuth",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/labour/dlSettlement/authPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/dlSettlement/auth.vue"),
        },






        {
            meta: {
                title: "代购材料进度款申请",
                permissionCode: "pcEngineerProjectLabourPaymentAgentProcessEdit",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:'pcEngineerProjectLabourPaymentAgentProcessForm'
            },
            path: "/engineering/labour/agentProgress/applyPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/agentProgress/apply.vue"),
        },
        {
            meta: {
                title: "代购材料进度款审核及详情",
                permissionCode: "pcEngineerProjectLabourPaymentAgentProcessAuth",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],


            },
            path: "/engineering/labour/agentProgress/authPay",
            component: () =>
                import("@/views/engineering/labour/payMgt/agentProgress/auth.vue"),
        },
        {
            meta: {
                title: "代购材料结算款申请",
                permissionCode: "pcEngineerProjectLabourPaymentAgentSettleEdit",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:'pcEngineerProjectLabourPaymentAgentSettleForm'
            },
            path: "/engineering/labour/agentSettlement/applyPay",
            component: () =>
                import(
                    "@/views/engineering/labour/payMgt/agentSettlement/apply.vue"
                ),
        },
        {
            meta: {
                title: "代购材料结算款审核及详情",
                permissionCode: "pcEngineerProjectLabourPaymentAgentSettleAuth",
                permissionRouterCode: ["pcEngineerProjectLabourPayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/labour/agentSettlement/authPay",
            component: () =>
                import(
                    "@/views/engineering/labour/payMgt/agentSettlement/auth.vue"
                ),
        },
        {
            meta: {
                title: "双包任务单管理",
                permissionCode: "pcEnginerrProjectDoubleTaskMgt",
            },
            path: "/engineering/double/taskMgt",
            component: () =>
                import("@/views/engineering/double/taskMgt/index.vue"),
        },
        {
            meta: {
                title: "班组管理",
                permissionCode: "pcEnginerrProjectDoubleTeam",
                keepAlive: true
            },
            path: "/engineering/double/team",
            component: () => import("@/views/engineering/double/team/index.vue"),
        },
        {
            meta: {
                title: "添加工人信息",
                permissionCode: "pcEnginerrProjectDoubleTeamAdd",
                state: "add",
                keepAlive: true,
                name:'pcEnginerrProjectDoubleTeamForm'
            },
            path: "/engineering/double/addTeam",
            component: () => import("@/views/engineering/double/team/detail.vue"),
        },
        {
            meta: {
                title: "修改工人信息",
                permissionCode: "pcEnginerrProjectDoubleTeamEdit",
                state: "edit",
                keepAlive: true,
                name:'pcEnginerrProjectDoubleTeamForm'
            },
            path: "/engineering/double/editTeam",
            component: () => import("@/views/engineering/double/team/detail.vue"),
        },
        {
            meta: {
                title: "查看工人信息",
                permissionCode: "pcEnginerrProjectDoubleTeamView",
                state: "look"
            },
            path: "/engineering/double/lookTeam",
            component: () => import("@/views/engineering/double/team/detail.vue"),
        },
        {
            meta: {
                title: "付款计划",
                permissionCode: "pcEnginerrProjectDoublePayTaskList",
                keepAlive: true,
                name:"pcEnginerrProjectDoublePayTaskList"
            },
            path: "/engineering/double/payTaskList",
            component: () =>
                import("@/views/engineering/double/payTask/list.vue"),
        },
        {
            meta: {
                title: "双包付款管理",
                permissionCode: "pcEngineerProjectDoublePayment",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectDoublePayment"
            },
            path: "/engineering/double/paymentList",
            component: () => import("@/views/engineering/double/payMgt/list.vue"),
        },
        {
            meta: {
                title: "材料双包进度款新增/修改",
                permissionCode: "pcEngineerProjectDoublePaymentProcessEdit",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectDoublePaymentProcessForm"
            },
            path: "/engineering/double/applyProgressPay",
            component: () =>
                import("@/views/engineering/double/payMgt/progress/applyPro.vue"),
        },
        {
            meta: {
                title: "材料双包进度款审核/详情",
                permissionCode: "pcEngineerProjectDoublePaymentProcessAuth",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/double/authProgressPay",
            component: () =>
                import("@/views/engineering/double/payMgt/progress/authPro.vue"),
        },
        {
            meta: {
                title: "材料双包结算款新增/修改",
                permissionCode: "pcEngineerProjectDoublePaymentSettleEdit",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectDoublePaymentSettleForm"
            },
            path: "/engineering/double/applySettlementPay",
            component: () =>
                import("@/views/engineering/double/payMgt/settlement/applySet.vue"),
        },
        {
            meta: {
                title: "材料双包结算款审核/详情",
                permissionCode: "pcEngineerProjectDoublePaymentSettleAuth",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/double/authSettlementPay",
            component: () =>
                import("@/views/engineering/double/payMgt/settlement/authSet.vue"),
        },


        {
            meta: {
                title: "专项分包预付款新增/修改",
                permissionCode: "pcEngineerProjectDoubleSpecialPaymentPreEdit",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectDoubleSpecialPaymentPreForm"
            },
            path: "/engineering/double/special/applyPrePay",
            component: () =>
                import("@/views/engineering/double/payMgt/special/pre/applyPro.vue"),
        },
        {
            meta: {
                title: "专项分包预付款审核/详情",
                permissionCode: "pcEngineerProjectDoubleSpecialPaymentPreAuth",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/double/special/authPrePay",
            component: () =>
                import("@/views/engineering/double/payMgt/special/pre/authPro.vue"),
        },
        {
            meta: {
                title: "专项分包进度款新增/修改",
                permissionCode: "pcEngineerProjectDoubleSpecialPaymentProcessEdit",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectDoubleSpecialPaymentProcessForm"
            },
            path: "/engineering/double/special/applyProgressPay",
            component: () =>
                import("@/views/engineering/double/payMgt/special/progress/applyPro.vue"),
        },
        {
            meta: {
                title: "专项分包进度款审核/详情",
                permissionCode: "pcEngineerProjectDoubleSpecialPaymentProcessAuth",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/double/special/authProgressPay",
            component: () =>
                import("@/views/engineering/double/payMgt/special/progress/authPro.vue"),
        },
        {
            meta: {
                title: "专项分包结算款新增/修改",
                permissionCode: "pcEngineerProjectDoubleSpecialPaymentSettleEdit",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
                keepAlive: true,
                name:"pcEngineerProjectDoubleSpecialPaymentSettleForm"
            },
            path: "/engineering/double/special/applySettlementPay",
            component: () =>
                import("@/views/engineering/double/payMgt/special/settlement/applySet.vue"),
        },
        {
            meta: {
                title: "专项分包结算款审核/详情",
                permissionCode: "pcEngineerProjectDoubleSpecialPaymentSettleAuth",
                permissionRouterCode: ["pcEngineerProjectDoublePayment", "pcWorkbenchPayment"],
            },
            path: "/engineering/double/special/authSettlementPay",
            component: () =>
                import("@/views/engineering/double/payMgt/special/settlement/authSet.vue"),
        },


        {
            meta: {
                title: "添加付款计划",
                permissionCode: "pcEnginerrProjectDoublePayTaskListAdd",
                state: "add",
                keepAlive: true,
                name:"pcEnginerrProjectDoublePayTaskListForm"
            },
            path: "/engineering/double/addPayTask",
            component: () =>
                import("@/views/engineering/double/payTask/detail.vue"),
        },
        {
            meta: {
                title: "修改付款计划",
                permissionCode: "pcEnginerrProjectDoublePayTaskListEdit",
                state: "edit",
                keepAlive: true,
                name:"pcEnginerrProjectDoublePayTaskListForm"
            },
            path: "/engineering/double/editPayTask",
            component: () =>
                import("@/views/engineering/double/payTask/detail.vue"),
        },
        {
            meta: {
                title: "查看付款计划",
                permissionCode: "pcEnginerrProjectDoublePayTaskListAuth",
                state: "look"
            },
            path: "/engineering/double/lookPayTask",
            component: () =>
                import("@/views/engineering/double/payTask/detail.vue"),
        },
        {
            meta: {
                title: "劳务班组管理",
                permissionCode: "pcEnginerrLabourTeam",
                keepAlive: true,
                name:"pcEnginerrLabourTeam"
            },
            path: "/engineering/labourAssets/team",
            component: () =>
                import("@/views/engineering/labourAssets/team/list.vue"),
        },
        {
            meta: {
                title: "添加劳务班组",
                permissionCode: "pcEnginerrLabourTeamAdd",
                state: "add",
                keepAlive: true,
                name:"pcEnginerrLabourTeamForm"
            },
            path: "/engineering/labourAssets/addTeam",
            component: () =>
                import("@/views/engineering/labourAssets/team/detail.vue"),
        },
        {
            meta: {
                title: "修改劳务班组",
                permissionCode: "pcEnginerrLabourTeamEdit",
                state: "edit",
                keepAlive: true,
                name:"pcEnginerrLabourTeamForm"
            },
            path: "/engineering/labourAssets/editTeam",
            component: () =>
                import("@/views/engineering/labourAssets/team/detail.vue"),
        },
        {
            meta: {
                title: "查看劳务班组",
                permissionCode: "pcEnginerrLabourTeamAuth",
                state: "look",
                keepAlive: true,
                name:"pcEnginerrLabourTeamForm"
            },
            path: "/engineering/labourAssets/lookTeam",
            component: () =>
                import("@/views/engineering/labourAssets/team/detail.vue"),
        },
        {
            meta: {
                title: "劳务工人管理",
                permissionCode: "pcEnginerrLabourWorkman",
                keepAlive: true,
                name:"pcEnginerrLabourWorkman"
            },
            path: "/engineering/labourAssets/workman",
            component: () =>
                import("@/views/engineering/labourAssets/workman/list.vue"),
        },
        {
            meta: {
                title: "添加工人信息",
                permissionCode: "pcEnginerrLabourWorkmanAdd",
                state: 'add',
                keepAlive: true,
                name:"pcEnginerrLabourWorkmanForm"
            },
            path: "/engineering/labourAssets/addWorkman",
            component: () =>
                import("@/views/engineering/labourAssets/workman/detail.vue"),
        },
        {
            meta: {
                title: "修改工人信息",
                permissionCode: "pcEnginerrLabourWorkmanEdit",
                state: 'edit',
                keepAlive: true,
                name:"pcEnginerrLabourWorkmanForm"
            },
            path: "/engineering/labourAssets/editWorkman",
            component: () =>
                import("@/views/engineering/labourAssets/workman/detail.vue"),
        },
        {
            meta: {
                title: "查看工人信息",
                permissionCode: "pcEnginerrLabourWorkmanAuth",
                state: 'look',
                keepAlive: true,
                name:"pcEnginerrLabourWorkmanForm"
            },
            path: "/engineering/labourAssets/lookWorkman",
            component: () =>
                import("@/views/engineering/labourAssets/workman/detail.vue"),
        },


        {
            meta: {
                title: "劳务公司管理",
                permissionCode: "pcEnginerrLabourCompany",
                keepAlive: true,
                name:"pcEnginerrLabourCompany"
            },
            path: "/engineering/labourAssets/company",
            component: () =>
                import("@/views/engineering/labourAssets/company/list.vue"),
        },
        {
            meta: {
                title: "添加劳务公司",
                permissionCode: "pcEnginerrLabourCompanyAdd",
                state: 'add',
                keepAlive: true,
                name:"pcEnginerrLabourCompanyForm"
            },
            path: "/engineering/labourAssets/addCompany",
            component: () =>
                import("@/views/engineering/labourAssets/company/detail.vue"),
        },
        {
            meta: {
                title: "修改劳务公司",
                permissionCode: "pcEnginerrLabouCompanyEdit",
                state: 'edit',
                keepAlive: true,
                name:"pcEnginerrLabourCompanyForm"
            },
            path: "/engineering/labourAssets/editCompany",
            component: () =>
                import("@/views/engineering/labourAssets/company/detail.vue"),
        },
        {
            meta: {
                title: "查看劳务公司",
                permissionCode: "pcEnginerrLabourCompanyAuth",
                state: 'look',
                keepAlive: true,
                name:"pcEnginerrLabourCompanyForm"
            },
            path: "/engineering/labourAssets/lookCompany",
            component: () =>
                import("@/views/engineering/labourAssets/company/detail.vue"),
        },

        {
            path: "finance",
            redirect: "/engineering/finance/partyB",
            meta: {
                title: "项目财务管理",
                permissionCode: "pcEnginerrProjectFinance",
            },
            component: () => import("@/router/EmptyComponent.vue"),
            children: [
                {
                    meta: {
                        title: "乙方付款台账",
                        permissionCode: "pcEnginerrProjectFinance",


                    },
                    path: "partyB",
                    component: () =>
                        import("@/views/engineering/finance/partyB/list.vue"),
                },
            ],
        },
        {
            path: "file",
            redirect: "/engineering/file/list",
            meta: {
                title: "资料管理",
                permissionCode: "pcEnginerrProjectFile",
                name: "pcEnginerrProjectFile",
                keepAlive: true
            },
            component: () => import("@/router/EmptyComponent.vue"),
            children: [
                {
                    meta: {
                        title: "列表",
                        permissionCode: "pcEnginerrProjectFile",
                        name: "pcEnginerrProjectFile",
                        keepAlive: true
                    },
                    path: "list",
                    component: () =>
                        import("@/views/engineering/file/mgt/list.vue"),
                },
                {
                    meta: {
                        title: "新增",
                        permissionCode: "pcEnginerrProjectFileAdd",
                        name: "pcEnginerrProjectFileAddForm",
                        keepAlive: true
                    },
                    path: "add",
                    component: () =>
                        import("@/views/engineering/file/mgt/append.vue"),
                },
                {
                    meta: {
                        title: "修改",
                        permissionCode: "pcEnginerrProjectFileEdit",
                        name: "pcEnginerrProjectFileEditForm",
                        keepAlive: true
                    },
                    path: "edit",
                    component: () =>
                        import("@/views/engineering/file/mgt/edit.vue"),
                },
                {
                    meta: {
                        title: "上传",
                        permissionCode: "pcEnginerrProjectFileUpload",
                        name: "pcEnginerrProjectFileUploadForm",
                        keepAlive: true
                    },
                    path: "upload",
                    component: () =>
                        import("@/views/engineering/file/mgt/upload.vue"),
                },
                {
                    meta: {
                        title: "详情",
                        permissionCode: "pcEnginerrProjectFileAuth",
                    },
                    path: "detail",
                    component: () =>
                        import("@/views/engineering/file/mgt/detail.vue"),
                },
            ],
        },
    ],
};
